import { isMarkAnimationDisabledScenario, scenarioFromPane } from './AnimationScenario';
import { getLabelMarkIdsForPane, getMoveLabelMarkIdSet } from './DataStorePaneStateUtility';
import { DataStorePaths } from './DataStorePaths';
import { IDataStore } from './IDataStore';

export type PaneMarkClassification = {
  enterMarkIds: number[];
  moveMarkIds: number[];
  moveLabelMarkIds: number[];
  allExitMarkIds: number[];
  exitMarkIds: number[];
};

export function getLabelMarkIds(ds: IDataStore, paneId: string): number[] {
  return getLabelMarkIdsForPane(ds.getValue.bind(ds) as (path: string) => unknown, paneId);
}

export function getMoveLabelMarkIds(fromDs: IDataStore, toDs: IDataStore, paneId: string): number[] {
  const result = getMoveLabelMarkIdSet(
    paneId,
    (id: string) => getLabelMarkIds(fromDs, id),
    (id: string) => getLabelMarkIds(toDs, id)
  );
  return Array.from(result.values()).sort((left, right) => left - right);
}

export function classifyPaneMarks(fromDs: IDataStore | null, toDs: IDataStore, paneId: string): PaneMarkClassification {
  if (isMarkAnimationDisabledScenario(scenarioFromPane(toDs, paneId))) {
    return {
      enterMarkIds: [],
      moveMarkIds: [],
      moveLabelMarkIds: [],
      allExitMarkIds: [],
      exitMarkIds: [],
    };
  }

  if (fromDs === null) {
    const enterMarkIds = DataStorePaths.markIds(toDs, paneId);
    return {
      enterMarkIds,
      moveMarkIds: [],
      moveLabelMarkIds: [],
      allExitMarkIds: [],
      exitMarkIds: [],
    };
  }

  const fromMarkIds = DataStorePaths.markIds(fromDs, paneId);
  const toMarkIds = DataStorePaths.markIds(toDs, paneId);
  const fromSet = new Set(fromMarkIds);
  const toSet = new Set(toMarkIds);
  const allExitMarkIds = fromMarkIds.filter((id) => !toSet.has(id));

  return {
    enterMarkIds: toMarkIds.filter((id) => !fromSet.has(id)),
    moveMarkIds: toMarkIds.filter((id) => fromSet.has(id)),
    moveLabelMarkIds: getMoveLabelMarkIds(fromDs, toDs, paneId),
    allExitMarkIds,
    exitMarkIds: [...allExitMarkIds],
  };
}
